import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message } from 'antd';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';

interface ImageTypeProps {
  imgtypeid: string;
}

const ImageType: React.FC<ImageTypeProps> = ({imgtypeid}) => {
  const [TypeName, setImageTypeName] = useState('');
  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
        handleLoadData();
      }, []);
      

  const handleSubmit = async () => {
    if (!TypeName) {
      message.error('Please fill in all fields');
      return;
    }   
    const userId = localStorage.getItem("UserId");

  // Map jsonData to the expected format and validate required fields
    const mappedData = {
      ImageTypeName: TypeName,
      CreatedBy: userId
    };

    try {
      const token = await fetchToken();
      if(imgtypeid === ""){
        await axios.post(`${API_URL}/api/ImageType/SaveImageTypes`, mappedData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          message.success('Image Type added successfully');
          setImageTypeName('');
      }
      else{
        // Map jsonData to the expected format and validate required fields
        const updatedData = {
          ImageTypeName: TypeName,
          UpdatedBy: userId,
          ImageTypeId: imgtypeid
        };

        await axios.put(`${API_URL}/api/ImageType/UpdateImageTypes`, updatedData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          message.success('Image Type updated successfully');
          setImageTypeName('');
      }
    } catch (error) {
      message.error('Failed to save the data');
    }
  };

  const handleLoadData = async () => {
    if(imgtypeid === "") return;
    try {
      const token = await fetchToken();
      const response = await axios.get(`${API_URL}/api/ImageType/GetImageTypeById/${imgtypeid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      setImageTypeName(response.data.imageTypeName);
    } catch (error) {
      message.error('Failed to load image type data');
    }
  }

  return (
    <Form layout="vertical" onFinish={handleSubmit}>
      <Form.Item label="Image Type Name" required>
        <Input
          value={TypeName}
          onChange={(e) => setImageTypeName(e.target.value)}
          placeholder="Enter image type name" maxLength={50}
        />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ImageType;